import { UpdateAssignmentParams } from "#models/updateAssignmentParams.interface";
import { Asset } from "@carnegie-learning/cure-types";
import { AssignmentPagination, AssignmentPaginationParameters } from "@carnegie-learning/data-access-angular-passport";
import { createAction, props } from "@ngrx/store";
import { PPAssignment as Assignment } from "cli-types";

// ------ Load data for a particular assignment based on ID (mainly for grading) - singular (no 's' prefix) ------
export const LOAD_CURRENT_STUDENT_ASSIGNMENT =
    "[Student] Load Current Assignment";
export const LOAD_CURRENT_STUDENT_ASSIGNMENT_FAIL =
    "[Student] Load Current Assignment Fail";
export const LOAD_CURRENT_STUDENT_ASSIGNMENT_SUCCESS =
    "[Student] Load Current Assignment Success";

export const LoadCurrentStudentAssignment = createAction(
    LOAD_CURRENT_STUDENT_ASSIGNMENT,
    props<{ assignmentID: number }>()
);
export const LoadCurrentStudentAssignmentFail = createAction(
    LOAD_CURRENT_STUDENT_ASSIGNMENT,
    props<{ payload: any }>()
);
export const LoadCurrentStudentAssignmentSuccess = createAction(
    LOAD_CURRENT_STUDENT_ASSIGNMENT_SUCCESS,
    props<{ payload: Assignment }>()
);

// ------ Load data for a particular assignment based on ID (mainly for grading) - singular (no 's' prefix) ------
export const LOAD_ALL_GRADE_ASSIGNMENT_ASSETS =
    "[Student] Load All Grade Assignment Assets";
export const LOAD_ALL_GRADE_ASSIGNMENT_ASSETS_FAIL =
    "[Student] Load All Grade Assignment Assets Fail";
export const LOAD_ALL_GRADE_ASSIGNMENT_ASSETS_SUCCESS =
    "[Student] Load All Grade Assignment Assets Success";

export const LoadAllGradeAssignmentAssets = createAction(
    LOAD_ALL_GRADE_ASSIGNMENT_ASSETS,
    props<{ assignments: Assignment[] }>()
);
export const LoadAllGradeAssignmentAssetsFail = createAction(
    LOAD_ALL_GRADE_ASSIGNMENT_ASSETS_FAIL,
    props<{ payload: any }>()
);
export const LoadAllGradeAssignmentAssetsSuccess = createAction(
    LOAD_ALL_GRADE_ASSIGNMENT_ASSETS_SUCCESS,
    props<{ assignments: Assignment[], assets: Asset[] }>()
);

// ------ Set Current Assignment ------
export const SET_CURRENT_STUDENT_ASSIGNMENT =
    "[Student] Set Current Assignment";
export const SetCurrentStudentAssignment = createAction(
    SET_CURRENT_STUDENT_ASSIGNMENT,
    props<{ payload: Assignment }>()
);

// ------ Set Current Assignment ------
export const CLEAR_CURRENT_STUDENT_ASSIGNMENT =
    "[Student] Clear Current Assignment";
export const ClearCurrentStudentAssignment = createAction(SET_CURRENT_STUDENT_ASSIGNMENT);

// ------ Load the entire list of assignment objects that need to be graded ------
export const LOAD_ASSIGNMENT_LIST = "[Student] Load Assignment List";
export const LOAD_ASSIGNMENT_LIST_FAIL = "[Student] Load Assignment List Fail";
export const LOAD_ASSIGNMENT_LIST_SUCCESS = "[Student] Load Assignment List Success";

export const LoadAssignmentList = createAction(
    LOAD_ASSIGNMENT_LIST,
    props<{ payload: AssignmentPaginationParameters }>()
);
export const LoadAssignmentListFail = createAction(
    LOAD_ASSIGNMENT_LIST_FAIL,
    props<{ payload: any }>()
);
export const LoadAssignmentListSuccess = createAction(
    LOAD_ASSIGNMENT_LIST_SUCCESS,
    props<{ payload: AssignmentPagination }>()
);

// ------ Update assignment in the entities list ------
export const UPDATE_STUDENT_ASSIGNMENT = "[Student] Update Assignment";
export const UPDATE_STUDENT_ASSIGNMENT_FAIL =
    "[Student] Update Assignment Fail";
export const UPDATE_STUDENT_ASSIGNMENT_SUCCESS =
    "[Student] Update Assignment Success";

export const UpdateStudentAssignment = createAction(
    UPDATE_STUDENT_ASSIGNMENT,
    props<{ params: UpdateAssignmentParams, assignmentID: number, quickEval: boolean }>()
);
export const UpdateStudentAssignmentFail = createAction(
    UPDATE_STUDENT_ASSIGNMENT_FAIL,
    props<{ payload: any }>()
);
export const UpdateStudentAssignmentSuccess = createAction(
    UPDATE_STUDENT_ASSIGNMENT_SUCCESS,
    props<{ payload: Assignment, quickEval: boolean }>()
);

// ------ Reset State ------
export const RESET_GRADES_STORE = "[Student] Reset Grades Store";
export const ResetGradesStore = createAction(RESET_GRADES_STORE);

